module.exports = __webpack_public_path__ + "176dada0b398d2d8eea0bf9ea3b1bd7f.svg";